import { ReactNode } from "react";

import { Box } from "@/components/layout/flexbox";

interface SectionTitleProps {
  children: ReactNode;
}

export function SectionTitle({ children }: SectionTitleProps) {
  return (
    <Box fontSize={20} fontWeight={600} minWidth="auto">
      {children}
    </Box>
  );
}
